// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__tm9Nw","error":"Textarea_error__2DKMi","readonly":"Textarea_readonly__2IoB8","disabled":"Textarea_disabled__7bfo_"};